import api from 'api';
import {
  dashboardMetaRecipesAsyncActionSuccess,
} from 'actions/dashboard';
import { Recipes } from 'records/Recipe';
import Menu from 'records/Menu';

export const RECIPES_ASYNC_ACTION_START = 'RECIPES_ASYNC_ACTION_START';
export const RECIPES_ASYNC_ACTION_ERROR = 'RECIPES_ASYNC_ACTION_ERROR';
export const RECIPES_ASYNC_COUNT_ACTION_SUCCESS = 'RECIPES_ASYNC_COUNT_ACTION_SUCCESS';
export const RECIPES_ASYNC_UPDATE_ACTION_SUCCESS = 'RECIPES_ASYNC_UPDATE_ACTION_SUCCESS';
export const RECIPES_CATEGORY_ASYNC_UPDATE_ACTION_SUCCESS = 'RECIPES_CATEGORY_ASYNC_UPDATE_ACTION_SUCCESS';
export const RECIPES_ASYNC_DUPLICATE_ACTION_SUCCESS = 'RECIPES_ASYNC_DUPLICATE_ACTION_SUCCESS';
export const RECIPES_RESET_STATE = 'RECIPES_RESET_STATE';
export const RECIPES_SET_DUP_RECIPEID = 'RECIPES_SET_DUP_RECIPEID';
export const RECIPES_UPDATE_SUCCESS = 'RECIPES_UPDATE_SUCCESS';

function recipesAsyncActionStart() {
  return {
    type: RECIPES_ASYNC_ACTION_START,
  };
}

function recipesAsyncActionError(error) {
  return {
    type: RECIPES_ASYNC_ACTION_ERROR,
    error,
  };
}

function recipesAsyncCountActionSuccess() {
  return {
    type: RECIPES_ASYNC_COUNT_ACTION_SUCCESS,
  };
}

function recipesAsyncUpdateSuccess(data) {
  return {
    type: RECIPES_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function recipesByCategoryAsyncUpdateSuccess(data, userCategoryId) {
  return {
    type: RECIPES_CATEGORY_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
    userCategoryId,
  };
}

function recipesAsyncDuplicateSuccess() {
  return {
    type: RECIPES_ASYNC_DUPLICATE_ACTION_SUCCESS,
  };
}

export function resetRecipesState() {
  return {
    type: RECIPES_RESET_STATE,
  };
}

export function setDuplicatedRecipeId(data) {
  return {
    type: RECIPES_SET_DUP_RECIPEID,
    data,
  };
}

function recipesUpdateSuccess(data) {
  return {
    type: RECIPES_UPDATE_SUCCESS,
    data,
  };
}

export function getRecipesCount() {
  return (dispatch, getState) => {
    dispatch(recipesAsyncActionStart());
    return api.request('recipe/count', 'get')
    .then((data) => {
      dispatch(recipesAsyncCountActionSuccess());
      dispatch(dashboardMetaRecipesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(recipesAsyncActionError('Unable to get a recipe count'));
      throw (err);
    });
  };
}

function formattedRecipesList(data, menus) {
  //remove invalid menu list in usedInMenus
  let recipes = data;
  recipes.map((recipe, rIndex) => {
    recipe.get('usedInMenus').map((menu, index) => {
      const findMenu = Menu.filterMenuById(menus, menu.get('menuId'));
      const currIndex = recipes.getIn([rIndex, 'usedInMenus']).findIndex((value, index) => {
        return value.get('menuId') == menu.get('menuId')
      });
      if(findMenu.size === 0) {
        recipes = recipes.deleteIn([rIndex, 'usedInMenus', currIndex]);
      } else {
        recipes = recipes.setIn([rIndex, 'usedInMenus', currIndex, 'menuTitle'], findMenu.first().title);
      }
    });
  });
  return recipes;
}

export function getRecipesAsync(brandId) {
  return (dispatch, getState) => {
    dispatch(recipesAsyncActionStart());
    return api.request(`recipe/list?brandId=${ brandId }`, 'get')
    .then((data) => {
      //remove invalid menu list in usedInMenus
      const menus = getState().menus.get('data');
      const recipes = formattedRecipesList(Recipes(data), menus);
      dispatch(recipesUpdateSuccess(recipes));
      return data;
    })
    .catch((err) => {
      dispatch(recipesAsyncActionError('Unable to get Recipes'));
      throw (err);
    });
  };
}

export function getRecipesList(brandId) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/list?brandId=${ brandId }`, 'get')
    .then((data) => {
      const menus = getState().menus.get('data');
      const recipes = formattedRecipesList(Recipes(data), menus);
      dispatch(recipesUpdateSuccess(recipes));
      return data;
    })
    .catch((err) => {
      dispatch(recipesAsyncActionError('Unable to get Recipes'));
      throw (err);
    });
  };
}

export function getRecipesByCategoryAsync(brandId, userCategoryId) {
  return (dispatch, getState) => {
    
    return api.request(`recipe/list?brandId=${ brandId }&recipeCategoryId=${ userCategoryId }`, 'get')
    .then((data) => {
      const menus = getState().menus.get('data');
      const recipes = formattedRecipesList(Recipes(data), menus);
      dispatch(recipesByCategoryAsyncUpdateSuccess(recipes, userCategoryId));
      return data;
    })
    .catch((err) => {
      dispatch(recipesAsyncActionError('Unable to get Recipes'));
      throw (err);
    });
  };
}

export function duplicateRecipeAsync(recipeId) {
  return (dispatch, getState) => {
    dispatch(recipesAsyncActionStart());
    return api.request(`recipe/duplicate?id=${recipeId}`, 'post')
    .then((data) => {
      dispatch(recipesAsyncDuplicateSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(recipesAsyncActionError('Unable to Duplicate Recipes'));
      throw (err);
    });
  };
}
